import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { cn } from "@/utils/theme";
import type { ReactNode } from "react";
import { NavLink, useLocation } from "react-router";

export function NavMain({
  title,
  items,
}: Readonly<{
  title: string;
  items: {
    title: string;
    url: string;
    icon?: ReactNode;
  }[];
}>) {
  const location = useLocation();
  const isActive = (url: string) => {
    return (
      location.pathname === url ||
      (location.pathname.startsWith(url + "/") && location.pathname !== url)
    );
  };

  return (
    <SidebarGroup className="relative" data-testid="nav-main">
      <SidebarGroupLabel>{title}</SidebarGroupLabel>
      <SidebarGroupContent className="flex flex-col gap-2">
        <SidebarMenu>
          {items.map((item) => {
            const isItemActive = isActive(item.url);
            return (
              <SidebarMenuItem
                key={item.title}
                className={cn(
                  "h-12 flex items-center justify-center",
                  isItemActive ? "text-action" : "text-body-loud",
                  "font-semibold leading-3xl",
                  !isItemActive && "hover:border-y hover:border-neutral-silent",
                  "relative",
                )}
              >
                <SidebarMenuButton tooltip={item.title} asChild>
                  <NavLink
                    to={item.url}
                    className="group flex items-center gap-4 px-3.5 w-full"
                    data-active={isItemActive ? "true" : "false"}
                  >
                    {item.icon}
                    <span className="font-semibold">{item.title}</span>
                  </NavLink>
                </SidebarMenuButton>
                {isItemActive && (
                  <div className="absolute left-0 top-0 h-[38px] w-[5px] bg-surface-action-solid rounded-r-md translate-y-[5px]" />
                )}
              </SidebarMenuItem>
            );
          })}
        </SidebarMenu>
      </SidebarGroupContent>
    </SidebarGroup>
  );
}
